import img from '../../assets/noah-miller.jpg';

const Noah = {
  name: 'Noah Miller',
  bio: 'Marketing. Most days Noah is wearing company swag. He thinks plants are nice for decoration and really appreciates how his kids are so good at watering their indoor plants. His kids are priority #1.',
  url: 'noah',
  img,
};

export default Noah;
